module.exports = __webpack_public_path__ + "static/media/splash-bg.34fad0b3.jpg";